import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { api } from "../lib/api";

export default function Page() {
  const params = useParams();
  const location = useLocation();
  // Resolve slug from route param OR pathname (for fixed routes like /about, /terms)
  const slug = params.slug || location.pathname.replace(/^\//, "");

  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!slug) return;
    setP(null); setErr(false);
    api.get(`/pages/${slug}`).then((r) => setP(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="container-page py-24 text-center"><div className="font-display text-3xl">Page not found.</div></div>;
  if (!p) return <div className="container-page py-16 text-sm text-muted-foreground">Loading…</div>;

  return (
    <article className="container-page py-16 max-w-3xl" data-testid={`page-${slug}`}>
      <h1 className="font-display text-5xl tracking-tight border-b border-border pb-4 mb-8">{p.title}</h1>
      <div className="prose prose-stone max-w-none text-base leading-[1.8] text-foreground whitespace-pre-line"
           dangerouslySetInnerHTML={{ __html: p.content
             .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
             .replace(/\*([^*\n]+?)\*/g, '<em>$1</em>')
             .replace(/`(.+?)`/g, '<code class="px-1 py-0.5 bg-muted rounded-sm text-sm">$1</code>') }} />
    </article>
  );
}
